import { HtmlBlock } from '@/cms/definitions/content-types';
import BuyInsuranceSettings from '../BuyInsuranceSettings';
import { exception } from '@/appinsights/logging/ApplicationInsightLog';

export class BasketSettings extends BuyInsuranceSettings {
	public subtitleDiscount = '<i>Plus</i>Kunde rabat ';
	public subtitlePrice = ' Samlet pris ';
	public rkiHeaderDFIM: string;
	public rkiPopoverDFIM: string;
	public shortMainTitleChooseInsurance: string; // = 'Forsikringer';
	public shortTitleChooseInsurance: string; // = 'Beregn';

	public moreInsurancesBlockShow: boolean;
	public moreInsurancesBlockHeader: string;
	public moreInsurancesBlockText: string;
	public moreInsurancesBlockBtnLabel: string;
	public moreInsurancesBlockBtnClass: string;
	public moreInsurancesBlockBtnlink: string;
	public moreInsurancesBlockMaxWidth: string;

	public constructor(settingsBlock: HtmlBlock) {
		super(settingsBlock);
		this.loadBasketSettings();
	}

	/**
	 * load settings from CMS if present
	 */
	private loadBasketSettings() {
		try {
			let setting: string;
			const settingsArr = this.settingsBlock.markup.split('$');
			settingsArr.forEach((setting_) => {
				setting = setting_.toLowerCase().trim();
				if (setting.includes('___')) {
					// ignore setting
				} else if (setting.startsWith('subtitlediscount=')) {
					this.subtitleDiscount = this.getSettingsValue(setting_);
				} else if (setting.startsWith('subtitleprice=')) {
					this.subtitlePrice = this.getSettingsValue(setting_);
				} else if (setting.startsWith('rkiheaderdfim=')) {
					this.rkiHeaderDFIM = this.getSettingsValue(setting_);
				} else if (setting.startsWith('rkipopoverdfim=')) {
					this.rkiPopoverDFIM = this.getSettingsValue(setting_);
				} else if (setting.startsWith('shortmaintitlechooseinsurance=')) {
					this.shortMainTitleChooseInsurance = this.getSettingsValue(setting_);
				} else if (setting.startsWith('shorttitlechooseinsurance=')) {
					this.shortTitleChooseInsurance = this.getSettingsValue(setting_);
				} else if (setting.startsWith('moreinsurancesblockshow=')) {
					this.moreInsurancesBlockShow = JSON.parse(this.getSettingsValue(setting_));
				} else if (setting.startsWith('moreinsurancesblockheader=')) {
					this.moreInsurancesBlockHeader = this.getSettingsValue(setting_);
				} else if (setting.startsWith('moreinsurancesblocktext=')) {
					this.moreInsurancesBlockText = this.getSettingsValue(setting_);
				} else if (setting.startsWith('moreinsurancesblockbtnlabel=')) {
					this.moreInsurancesBlockBtnLabel = this.getSettingsValue(setting_);
				} else if (setting.startsWith('moreinsurancesblockbtnclass=')) {
					this.moreInsurancesBlockBtnClass = this.getSettingsValue(setting_);
				} else if (setting.startsWith('moreinsurancesblockbtnlink=')) {
					this.moreInsurancesBlockBtnlink = this.getSettingsValue(setting_);
				} else if (setting.startsWith('moreinsurancesblockmaxwidth=')) {
					this.moreInsurancesBlockMaxWidth = this.getSettingsValue(setting_);
				}
			});
		} catch (e) {
			exception(e);
		}
	}
}
